<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs8>
        <message-widget />
        <statistics />
      </v-flex>
      <v-flex xs4>
        <stages />
      </v-flex>
      <update-password :type="type" ref="updatePassword" />
    </v-layout>
  </v-container>
</template>

<script>
import Statistics from './Statistics'
import Stages from './Stages'
import MessageWidget from '../Bulletin/Widget'
import UpdatePassword from '@/components/UpdatePassword'

export default {
  components: {
    Statistics,
    Stages,
    MessageWidget,
    UpdatePassword,
  },
  data() {
    return {
      scope: 'public',
      change: this.$route.query.changePassword,
      type: this.$route.query.type,
    }
  },
  methods: {},
  mounted() {
    if (this.change === true || this.change === 'true') {
      this.$refs.updatePassword.popup(true)
    }
  },
}
</script>
